import { WaterType } from '@core/referential/water-type.enum'
import { z } from 'zod'

import { numberOrStringToNumberSchema } from '@shared/schema/utils'

export const GetSiteLegionellaSensorRoomMapPathParameterSchema = z.object({
  siteId: numberOrStringToNumberSchema,
})

// One entry per legionella sensor, i.e. per device attached to an equipment.
// temperature: last reading of the window (calibration offset applied), null = no recent data.
// waterType: derived from the device subType, drives the hot/cold icon on the card.
const LegionellaSensorSchema = z.object({
  deviceId: z.string().uuid(),
  deviceName: z.string(),
  equipmentId: z.string().uuid(),
  equipmentName: z.string(),
  equipmentRefName: z.string(),
  waterType: z.nativeEnum(WaterType).nullable(),
  temperature: z.number().nullable(),
})

export const GetSiteLegionellaSensorRoomMapResponseSchema = z.object({
  name: z.string(),
  id: numberOrStringToNumberSchema,
  buildings: z.array(
    z.object({
      name: z.string(),
      id: numberOrStringToNumberSchema,
      floors: z.array(
        z.object({
          id: numberOrStringToNumberSchema,
          name: z.string(),
          sensors: z.array(LegionellaSensorSchema),
        }),
      ),
    }),
  ),
})

export type LegionellaSensor = z.infer<typeof LegionellaSensorSchema>
export type GetSiteLegionellaSensorRoomMapPathParameter = z.infer<typeof GetSiteLegionellaSensorRoomMapPathParameterSchema>
export type GetSiteLegionellaSensorRoomMapResponse = z.infer<typeof GetSiteLegionellaSensorRoomMapResponseSchema>
